import React, { useEffect, useState } from "react";
import Table from "../../../../core/common/dataTable/index";
import { ColumnsType } from "antd/es/table";
import { cellWidth } from "../../../../core/methods/tableCellWidth";
import { useNavigate } from "react-router";
import FiltersTrackCase, {
  FiltersSelectType,
  initialFilterSelect,
  SearchFormDataType,
} from "../FiltersTrackCase";
import EditIcon from "../../../../core/svg-icons/EditIcon";
import { dummyData_ExtraCost } from "../../../../core/data/js/dummy-data";
import { parseDate, safeLocaleCompare } from "../../../../core/methods/sorterMethods";
import { formattedDate } from "../../../../core/methods/formattedDate";
import useApi from "../../../../core/customhook/useApi";
import webservice_url from "../../../../core/webservice/Webservice_url";

type Props = {
  status_id: string
}

const ExtraCost: React.FC<Props> = ({ status_id }) => {
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });
  const [filterData, setFilterData] = useState<FiltersSelectType>(initialFilterSelect);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });

  const { callApi: handlesSearch, data: dataList, loading: searchLoading } = useApi(webservice_url.hr_reports, {
    method: "POST",
    autoCall: false
  })

  const fetchData = async (
    page = pagination.current,
    pageSize = pagination.pageSize
  ) => {
    const payload = {
      status: status_id || null,
      org_ids:
        filterData?.organization ||
        null,
      project_ids:
        filterData?.project ||
        null,
      program_ids:
        filterData?.program ||
        null,
      department_ids:
        filterData?.departments ||
        null,
      page,
      limit: pageSize,
    };

    try {
      const response = await handlesSearch(payload);

      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: response?.data?.total || 0,
      }));
    } catch (error) {
      console.error("API Failed", error);
    }
  };

  const handleTableChange = async (
    pagination: any
  ) => {

    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));

  };
  // ---- columns ----
  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      align: "center",
      sorter: false,
    },
    {
      title: "Applicant Name",
      dataIndex: "applicant_name",
      onCell: () => cellWidth(200),
      render: (text) => (
        <div
        style={{cursor:"pointer"}}
          className="btn-link "
          onClick={() => {
            // navigate(all_routes.insufficiencyDetails);
          }}
        >
          {text}
        </div>
      ),
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_name"),
    },
    {
      title: "SBU Name",
      dataIndex: "sbu_name",
      onCell: () => cellWidth(140),
      sorter: (a, b) => safeLocaleCompare(a, b, "sbu_name"),
    },
    {
      title: "Case Id",
      dataIndex: "case_id",
      onCell: () => cellWidth(110),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_id"),
    },
    {
      title: "Check Name",
      dataIndex: "check_name",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "check_name"),
    },
    {
      title: "Key Value",
      dataIndex: "key_value",
      render: (text: string) => <div style={{ width: 200 }}>{text}</div>,
      sorter: (a, b) => safeLocaleCompare(a, b, "key_value"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) =>
        parseFloat(a.amount.replace(/[^\d.]/g, "")) -
        parseFloat(b.amount.replace(/[^\d.]/g, "")),
    },
    {
      title: "Approval Status",
      dataIndex: "approval_status",
      sorter: (a, b) => safeLocaleCompare(a, b, "approval_status"),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text: string) => {
        const date = formattedDate(text) ?? "-";
        return <span>{date}</span>
      },
      sorter: (a: any, b: any) =>
        parseDate(a.created_at).getTime() - parseDate(b.created_at).getTime()
    },
    {
      title: "Case Spoc",
      dataIndex: "case_spoc",
      onCell: () => cellWidth(130),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_spoc"),
    },
    {
      title: "Email Id",
      dataIndex: "email_id",
      sorter: (a, b) => safeLocaleCompare(a, b, "email_id"),
    },
    {
      title: "Payment Link",
      dataIndex: "payment_link",
      onCell: () => cellWidth(150),
      sorter: (a, b) => safeLocaleCompare(a, b, "payment_link"),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      sorter: (a, b) => safeLocaleCompare(a, b, "payment_status"),
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   onCell: () => cellWidth(190),
    //   render: () => (
    //     <div className="dropdown">
    //       <button
    //         type="button"
    //         className="btn btn-xs dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //         style={{ textWrap: "wrap" }}
    //       >
    //         <EditIcon />
    //         &nbsp;Approval Required
    //       </button>
    //       <ul className="dropdown-menu ">
    //         <li>
    //           <button
    //             type="button"
    //             className="dropdown-item"
    //             // onClick={() => setShowModifyInvite(true)}
    //           >
    //             Approve by HR
    //           </button>
    //         </li>
    //       </ul>
    //     </div>
    //   ),
    // },
  ];


  useEffect(() => {
    if (dataList?.data?.rows) {
      setItemList(dataList.data.rows);
    }
  }, [dataList]);

  // useEffect(() => {
  //   fetchData(1, pagination.pageSize);
  // }, [searchTrigger]);

  return (
    <div>
      {/* filters */}
      <FiltersTrackCase
        filterData={filterData}
        searchFilter={searchFilter}
        setFilterData={setFilterData}
        setSearchFilter={setSearchFilter}
        onSearch={() => setSearchTrigger(prev => prev + 1)}
      />

      {/* Table  */}
      <div className="card mt-3">
        <Table
          dataSource={itemList}
          columns={columns}
          Selection={false}
          pagination={pagination}
          handleTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default ExtraCost;
